import { render, staticRenderFns } from "./MissedCallsFab.vue?vue&type=template&id=6c2ef8d4&"
import script from "./MissedCallsFab.vue?vue&type=script&lang=js&"
export * from "./MissedCallsFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports